<template>
    <div class="ly-note--select">
        <div class="ly-note--select__item" v-for="(el, i) in  selectOptions" :key="i">
            <el-select v-model="selectChange[i]" @change="handleChange(i)">
                <el-option v-for="(item, j) in  selectOptions" :key="j" :label="item.label" :value="item.prop"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                value: _ => []
            }
        },
        data () {
            return {
                selectOptions: [
                    {"label":"交易日期","prop":"trade_time"},
                    {"label":"银行账号","prop":"account_number"},
                    {"label":"银行账户名称","prop":"account_name"},
                    {"label":"对方信息","prop":"duifangxinxi"},
                    {"label":"支出金额","prop":"zhichu_amount"},
                    {"label":"收入金额","prop":"shouru_amount"},
                    {"label":"余额","prop":"balance_amount"},
                    {"label":"交易方式","prop":"trade_way"},
                    {"label":"交易往来","prop":"trade_transact"},
                    {"label":"交易渠道","prop":"trade_channel"},
                    {"label":"交易说明","prop":"trade_remark"}
                ],
                lastSelectChange: [], // 记录select改变之前的数据
                selectChange:[], // 当前选中的值
                canChange: false, // 标识是否之行选中监听
            }
        },
        created () {
            // 初始化select中选中的内容
            for (let i = 0, len = this.selectOptions.length; i < len; i++) {
                this.lastSelectChange[i] = this.selectChange[i] = this.selectOptions[i]['prop']
            }
            this.doInput()
        },
        methods: {
            /**
             * select选中值变化监听
             * @param i 第几个select变化了
             */
            handleChange (i) {
                this.canChange = !this.canChange
                if (!this.canChange) {
                    return
                }
                // 获取当前值是，属于第几个的
                let targetIndex = this.lastSelectChange.findIndex((el) => {
                    return el === this.selectChange[i]
                })
                // 当前选中列表目标值，为 当前选中的原来值
                // 对目标select设置当前镜像的值
                this.$set(this.selectChange, targetIndex, this.lastSelectChange[i])
                // 将副本中的值与selectChange 同步
                this.lastSelectChange[i] = this.selectChange[i]
                this.lastSelectChange[targetIndex] = this.selectChange[targetIndex]
                this.doInput()
            },
            /**
             * 数据回传回去
             */
            doInput () {
                // 回传的数据
                let arr = []
                for (let i = 0, len = this.selectChange.length; i < len; i++) {
                    let prop = this.selectChange[i]
                    let option = this.selectOptions.find((el) => {
                        return prop === el.prop
                    })
                    arr.push(option)
                }
                this.$emit('input', arr)
            }
        }
    }
</script>

<style>
    /* .ly-note--operation {
        outline: 1px solid red;
    } */
    /* 列名的选择器 */
    .ly-note--select {
        position: relative;
        border-right: 1px solid #dcd6ca;    
        box-shadow: rgba(0,0,0,.1) 1px 0 3px;
        z-index: 1;
    }
    .ly-note--select__item {
        position: relative;
        width: 160px;
        height: 50px;
        box-sizing: border-box;
        padding: 7px 10px;
        z-index: 10;
    }
    .ly-note--select__item .el-input__inner {
        background-color: transparent;
    }
</style>